// react-i18next bootstrap. Loaded once from index.js before <App /> renders.
// Language priority: user pref (localStorage `gw_language`) → browser
// language → English fallback (per user's spec).
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fil from "./locales/fil.json";
import ru from "./locales/ru.json";

export const SUPPORTED_LANGUAGES = [
  { code: "it",  label: "Italiano",   flag: "🇮🇹" },
  { code: "en",  label: "English",    flag: "🇬🇧" },
  { code: "de",  label: "Deutsch",    flag: "🇩🇪" },
  { code: "fil", label: "Filipino",   flag: "🇵🇭" },
  { code: "ru",  label: "Русский",    flag: "🇷🇺" },
];

export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(l => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it:  { translation: it },
      en:  { translation: en },
      de:  { translation: de },
      fil: { translation: fil },
      ru:  { translation: ru },
    },
    fallbackLng: "en",           // per user's decision
    supportedLngs: LANGUAGE_CODES,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "gw_language",
      caches: ["localStorage"],
    },
  });

export default i18n;
